export default __webpack_public_path__ + "static/media/icon.medical-kits.5a7d0cea.svg";